import Vue from 'vue'
import Router from 'vue-router'
import LecturerMyPage from 'components/lecturer/Mypage'
import LecturerLoginPage from 'components/lecturer/Login'
import LecturerInquiryPage from 'components/lecturer/Inquiry'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/lecturer',
  routes: [
    {
      path: '/login',
      component: LecturerLoginPage,
      meta: {
        title: 'ログインページ',
        requiresAuth: false
      }
    },
    {
      path: '/password',
      component: require('components/lecturer/Password.vue'),
      meta: {
        title: 'パスワード再発行'
      }
    },
    {
      path: '/mypage',
      component: LecturerMyPage,
      meta: {
        title: '講師用管理画面',
        requiresAuth: true
      }
    },
    {
      path: '/inquiry',
      component: LecturerInquiryPage,
      meta: {
        title: 'お問合せ',
        requiresAuth: true
      }
    },
    {
      path: '/input',
      component: require('components/lecturer/event/InputRoot.vue'),
      meta: {
        title: '撮影会／イベント／教室 登録',
        requiresAuth: true
      }
    },
    {
      path: '/list',
      component: require('components/lecturer/event/EventList.vue'),
      meta: {
        title: '撮影会／イベント／教室 一覧画面 ｜ 講師用管理画面',
        requiresAuth: true
      }
    },
    {
      path: '/report_input',
      component: require('components/lecturer/event/ReportInput.vue'),
      meta: {
        title: '撮影会／イベント／教室 開催報告',
        requiresAuth: true
      }
    },
    {
      path: '/report_confirm',
      component: require('components/lecturer/event/ReportConfirm.vue'),
      meta: {
        title: '撮影会／イベント／教室 開催報告確認',
        requiresAuth: true
      }
    },
    {
      path: '/profile',
      component: require('components/lecturer/profile/Index.vue'),
      meta: {
        title: '講師用管理画面',
        requiresAuth: true
      }
    },
    {
      path: '/profile/edit',
      component: require('components/lecturer/profile/Edit.vue'),
      meta: {
        title: '講師用管理画面',
        requiresAuth: true
      }
    },
    {
      path: '/profile/detail',
      component: require('components/lecturer/profile/Detail.vue'),
      meta: {
        title: '講師用管理画面',
        requiresAuth: true
      }
    },
    {
      path: '/profile/edit-email',
      component: require('components/lecturer/profile/EditEmail.vue'),
      meta: {
        title: '講師用管理画面',
        requiresAuth: true
      }
    },
    {
      path: '/email/edited/:token',
      component: require('components/lecturer/profile/EditedEmail.vue'),
      meta: {
        title: '講師用管理画面',
        requiresAuth: false
      }
    },
    {
      path: '/profile/edit-password',
      component: require('components/lecturer/profile/EditPassword.vue'),
      meta: {
        title: '講師用管理画面',
        requiresAuth: true
      }
    },
    {
      path: '/:event_kind/details/:id',
      name: 'event_details',
      component: require('components/lecturer/event/Details'),
      meta: {
        title: '撮影会／イベント／教室 詳細',
        requiresAuth: true
      }
    },
    {
      path: '/download',
      component: require('components/lecturer/Download'),
      meta: {
        title: 'ファイルダウンロード',
        requiresAuth: true
      }
    },
    {
      path: '/download-external-study-session-docs',
      component: require('components/lecturer/DownloadExternalStudySessionDocs'),
      meta: {
        title: '勉強会資料ダウンロード',
        requiresAuth: true
      }
    },
    {
      path: '/download-internal-study-session-docs',
      component: require('components/lecturer/DownloadInternalStudySessionDocs'),
      meta: {
        title: '勉強会資料ダウンロード',
        requiresAuth: true
      }
    },
    {
      path: '/event/confirm',
      component: require('components/lecturer/event/confirm/EventConfirm'),
      meta: {
        title: '撮影会／イベント／教室 登録',
        requiresAuth: true
      }
    },
    {
      path: '/photo/confirm',
      component: require('components/lecturer/event/confirm/PhotoConfirm'),
      meta: {
        title: '撮影会／イベント／教室 登録',
        requiresAuth: true
      }
    },
    {
      path: '/school/confirm',
      component: require('components/lecturer/event/confirm/SchoolConfirm'),
      meta: {
        title: '撮影会／イベント／教室 登録',
        requiresAuth: true
      }
    },
    {
      path: '',
      redirect: '/login'
    },
    {
      path: '*',
      redirect: '/login'
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js